<template>
  <v-container>
    <ActiveApp v-if="isAactiveApp" />
    <div v-if="!isAactiveApp">
      <h1 class="headline1">المنصة الرقمية لشركة تطوير للنقل (رافد)</h1>
      <v-layout v-if="!is_sub" text-center wrap>
        <div
          v-for="({ title, description, icon, url, is_group, name },
          index) in apps"
          :key="index"
          class="app-card"
          @click="goToApp(url, is_group, name)"
        >
          <v-card
            dark
            width="300"
            height="150"
            :elevation="elevations[index].value"
            @mouseover="setElevation(index, 10)"
            @mouseleave="setElevation(index, 1)"
          >
            <v-card-title>
              <!--               <img width="60" style="  margin-left: auto;margin-right: auto;  display: block;" :src="icon.match(/.*\((.*)\)/)[1]" />
 -->
              <v-card-text class="font-weight-bold">{{ title }}</v-card-text>
            </v-card-title>
          </v-card>
        </div>
      </v-layout>

      <v-layout v-if="is_sub" text-center wrap>
        <div
          v-for="({ title, description, icon, url, is_group, name },
          index) in subapps"
          :key="index"
          class="app-card"
          @click="goToApp(url, is_group, name)"
        >
          <v-card
            dark
            width="300"
            height="150"
            :elevation="elevations[index].value"
            @mouseover="setElevation(index, 10)"
            @mouseleave="setElevation(index, 1)"
          >
            <v-card-title>
              <!--               <img width="60" style="  margin-left: auto;margin-right: auto;  display: block;" :src="icon.match(/.*\((.*)\)/)[1]" />
 -->
              <v-card-text class="font-weight-bold">{{ title }}</v-card-text>
            </v-card-title>
          </v-card>
        </div>
        <div v-if="is_sub" dark class="app-card" @click="goBack()">
          <v-card dark max-width="300" min-width="300" min-height="150">
            <br />
            <br />
            <span class>عودة</span>

            <v-card-text class="font-weight-bold"
              >عوده الى انظمه النقل</v-card-text
            >
          </v-card>
        </div>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import ActiveApp from "./ActiveApp";
import alasql from "alasql";
import _ from "lodash";

export default {
  components: {
    ActiveApp,
  },
  mounted() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been rendered
      this.loadConfigJson();
    });
  },
  data() {
    return {
      is_sub: false,
      elevations: {
        0: { value: 2 },
        1: { value: 2 },
        2: { value: 2 },
        3: { value: 2 },
        4: { value: 2 },
        5: { value: 2 },
        6: { value: 2 },
        7: { value: 2 },
        8: { value: 2 },
        9: { value: 2 },
        10: { value: 2 },
        11: { value: 2 },
        12: { value: 2 },
      },
    };
  },
  computed: {
    apps() {
      return _.uniqBy(this.$store.state.ttcapps, "name");
    },
    subapps() {
      return _.uniqBy(this.$store.state.ttcsub_apps, "name");
    },
    isAactiveApp() {
      return this.$store.state.activeApp != null;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },

    userPrivilege() {
      return this.$store.state.userPrivilege;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logoutAction", {});
    },
    istokenValid() {
      var base64Url = this.$store.state.token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      var expirationDate = JSON.parse(jsonPayload).exp;
      if (expirationDate > Date.now() / 1000) {
        return true;
      }

      return false;
    },
    async userRolesJson() {
      var roles = [];
      var userPrivilege = this.userPrivilege;
      //console.log(this.userPrivilege);
      roles = userPrivilege["Roles"].map(
        ({ RoleName }) => "'" + this.extractRole(`${RoleName}`) + "'"
      );

      roles[roles.length] = "'" + "reports" + "'";
      return roles;
    },
    async loadConfigJson() {
      await alasql.promise([
        "CREATE TABLE  IF NOT EXISTS APPS",
         'SELECT * INTO APPS FROM CSV("https://ets.tatweertransit.com/api/apps.csv",{headers:true})'
      //  'SELECT * INTO APPS FROM CSV("http://localhost:8080/api/apps.csv",{headers:true})',
      ]);

      let roles = await this.userRolesJson();
      let apps = await alasql(
        `SELECT * FROM APPS WHERE name <>"" and is_main="checked" and  acls= ANY (ARRAY[${roles}]) order by sort asc`
      );

      //console.log( `SELECT * FROM APPS WHERE name <>"" and is_main="checked" and  acls= ANY (ARRAY[${roles}]) order by sort asc`);

      this.$store.dispatch("setAppsAction", apps);
    },

    extractRole(role) {
      var res = role.split("_");
      return res[0];
    },
    userRoles() {
      var roles = [];
      var userPrivilege = this.$store.state.userPrivilege;
      roles = userPrivilege["Roles"].map(
        ({ RoleName }) => "'" + this.extractRole(`${RoleName}`) + "'"
      );

      roles[roles.length] = "'" + "reports" + "'";
      return roles;
    },
    async goToApp(appUrl, is_group, name) {
      if (this.istokenValid()) {
        if (name == "ttc-avl-search-micro-app") {

          window.open(`${appUrl}?token=${this.$store.state.token}`, '_blank');



        } else {
          if (JSON.stringify(is_group) == JSON.stringify("checked")) {
            let apps2 = await alasql(
              `SELECT * FROM APPS WHERE name <>"" and is_main!="checked" and  acls= ANY (ARRAY[${this.userRoles()}]) and parent_app="` +
                name +
                '" order by sort asc'
            );

            this.$store.dispatch("setSubAppsAction", apps2);
            this.is_sub = true;
          } else {
            this.is_sub = false;

            this.$store.dispatch("setActiveAppAction", appUrl);
          }
        }
      } else {
        this.logout();
      }
    },
    goBack() {
      this.is_sub = false;
    },
    setElevation(index, value) {
      //console.log("setElevation", index, value);
      this.elevations[index] = { value };
    },
  },
};
</script>

<style scoped>
.app-card {
  margin: 10px;
  cursor: pointer;
  background-color: #ffffff !important;
  border-color: #e1532e !important;
  border-style: solid;
  border-width: thin;
}
.headline1 {
  text-align: center;
  margin: 30px;
  color: #ffffff;
}
</style>
